import { Component, Vue, Watch } from "vue-property-decorator";
import Axios from "../../../plugins/http";

function downFileByStream(fileRes: any, fileObj: { name: any; type: any }) {
  let objectUrl = window.URL.createObjectURL(new Blob([fileRes],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));
  let link = document.createElement("a");
  link.style.display = "none";
  link.href = objectUrl;
  // 带拓展名
  // link.setAttribute('download', `${filename}.xlsx`);
  link.setAttribute(
    "download",
    fileObj.type ? `${fileObj.name}.${fileObj.type}` : `${fileObj.name}.xlsx`
  );
  document.body.appendChild(link);
  link.click();
}

@Component
export default class customeService extends Vue {
  token: any = window.localStorage.getItem("token") || "";
  search: any = {
    orderName: "",
    search: "",
  };
  tableData: any = [];
  pageNo: number = 1;
  pageSize: number = 20;
  total: number = 0;

  cpList: any = [];
  isShow: boolean = false;
  form: any = {
    id: "",
    cpCode: "",
  };
  isConfirm: boolean = false;
  Loading:any = null;
  created() {
    this.getCpList();
    this.getList();
  }
  onSearch() {
    this.pageNo = 1;
    this.getList();
  }
  onRest() {
    this.search = {
      orderName: "",
      search: "",
    };
    this.pageNo = 1;
    this.getList();
  }
  getCpList() {
    Axios.getSecret("/api/common/logistics/all").then((res: any) => {
      if (res.data.status == 200) {
        this.cpList = res.data.data || [];
      }
    });
  }
  getList() {
    let { orderName, search } = this.search;
    let data = {
      condition: {
        orderName,
        search,
      },
      pageNo: this.pageNo,
      size: this.pageSize,
    };
    Axios.postByJson("/api/order/import/file/page", data).then((res: any) => {
      if (res.data.status == 200) {
        this.tableData = res.data.data.records || [];
        this.pageNo = Number(res.data.data.current);
        this.total = Number(res.data.data.total);
      } else {
        this.tableData = [];
        this.pageNo = 1;
        this.total = 0;
      }
    });
  }
  changePage(pageNo: number) {
    this.pageNo = pageNo;
    this.getList();
  }
  onProgress(){
    this.Loading = this.$loading({
      lock: true,
      text: '正在导入中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
  }
  onExport(props:any){
    Axios.postByJsonBlob('/api/order/export',{
      id:props.id
    }).then((res:any)=>{
      downFileByStream(res.data, {
        name: `${Date.now()}`,
        type: "xlsx",
      });
    })
  }
  handleSuccess(res: any, file: any, fileList: any) {
    this.Loading.close();
    this.Loading = null;
    if (res.status == 200) {
      this.$message({
        type: "success",
        message: "导入成功",
      });
      this.getList();
    } else if (res.status === 125) {
      this.$confirm(res.msg, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let formData = new FormData();
          formData.append("file", file.raw);
          formData.append("isConfirm", "true");
          Axios.formAjax({
            url: "/api/order/import",
            method: "post",
            data: formData,
            headers: {
              token: this.token,
            },
          }).then(({ data }) => {
            this.$message({
              type: "success",
              message: "导入成功",
            });
            this.getList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    } else {
      this.$message.error(res.msg);
    }
  }
  beforeUpload(file: any) {
    const isXlsx =
      file.name.substring(file.name.lastIndexOf(".") + 1) == "xlsx";
    if (!isXlsx) {
      this.$message.error("上传文件只能是xlsx格式!");
    }
    return isXlsx;
  }
  onRename(props: any) {
    this.$prompt("请输入名称", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
    })
      .then(({ value }: any) => {
        let data = {
          id: props.id,
          name: value,
        };
        Axios.postByJson("/api/order/import/file/rename", data).then(
          (res: any) => {
            if (res.data.status == 200) {
              this.$message({
                type: "success",
                message: "重命名成功",
              });
              this.getList();
            } else {
              this.$message.error(res.data.msg);
            }
          }
        );
      })
      .catch(() => {});
  }
  handleClose() {
    this.form.id = "";
    this.form.cpCode = "";
    this.isShow = false;
  }
  onPush(props: any) {
    this.form.id = props.id;
    this.isShow = true;
  }
  onSubmit() {
    if (this.form.cpCode === "") {
      this.$message.error("请选择快递公司");
      return;
    }
    let data = {
      id: this.form.id,
      cpCode: this.form.cpCode,
    };
    const Load = this.$loading({
      lock: true,
      text: '正在推送中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    Axios.postByJson("/api/order/import/file/push", data).then((res: any) => {
      Load.close()
      if (res.data.status == 200) {
        this.$message({
          type: "success",
          message: `您使用了一键推送，本次成功数据${res.data.data.success}条，失败数据${res.data.data.fail}条。`,
        });
        this.handleClose();
        this.getList();
      } else {
        this.$message.error(res.data.msg);
      }
    });
  }
  onDel(props: any) {
    this.$confirm("是否确认删除？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        let data = {
          id: props.id,
        };
        Axios.postByJson("/api/order/import/file/delete", data).then(
          (res: any) => {
            if (res.data.status == 200) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.getList();
            } else {
              this.$message.error(res.data.msg);
            }
          }
        );
      })
      .catch(() => {
        this.$message({
          type: "info",
          message: "已取消",
        });
      });
  }
  onJump(props: any) {
    this.$router.push({
      path: "batchAddOrder/details",
      query: {
        id: props.id,
      },
    });
  }
}
